"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DATES_OFFSET = void 0;
exports["default"] = fillDates;
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));
var _subDays = _interopRequireDefault(require("date-fns/subDays"));
var _addDays = _interopRequireDefault(require("date-fns/addDays"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _userflow = require("../../constants/userflow");
var DATES_OFFSET = exports.DATES_OFFSET = 10;
var DEMANDED_DAYS_OFFSET = 2;
var now = new Date();
var nextDay = (0, _addDays["default"])(now, 1);

/**
 * Дополняет массив дат с ценами пустыми датами
 * @typedef {Object} Date
 * @property {string} date 'DD.MM.YYYY'
 * @property {number} price
 * @param {Date[]} dates
 * @param {string} currentDate 'DD.MM.YYYY' // почему сейчас приходит Date()?
 */
function fillDates(dates, currentDate) {
  var dateFrom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nextDay;
  if (!Array.isArray(dates)) {
    return null;
  }
  var currentDateMoment = (0, _parse["default"])(currentDate, _userflow.DATE_FORMAT_CLIENT, new Date());
  var substractedDate = (0, _subDays["default"])(currentDateMoment, DATES_OFFSET);
  var startDate = (0, _isBefore["default"])(substractedDate, dateFrom) ? dateFrom : substractedDate;
  var leftDate = (0, _subDays["default"])(currentDateMoment, DEMANDED_DAYS_OFFSET);
  var rightDate = (0, _addDays["default"])(currentDateMoment, DEMANDED_DAYS_OFFSET);
  var filledArray = Array(DATES_OFFSET * 2 + 1).fill(null).map(function (i, index) {
    var date = (0, _addDays["default"])(startDate, index);
    var formattedDate = (0, _format["default"])(date, _userflow.DATE_FORMAT_CLIENT);
    var datesItem = dates && dates.find(function (item) {
      return item.date === formattedDate;
    });
    var _ref = datesItem || {},
      price = _ref.price,
      pricePerNight = _ref.pricePerNight;
    var priceOnDemand = !(0, _isWithinInterval["default"])(date, {
      start: leftDate,
      end: rightDate
    }) && !datesItem;
    return {
      date: formattedDate,
      price: price,
      priceOnDemand: priceOnDemand,
      pricePerNight: pricePerNight
    };
  });
  return filledArray;
}